<template>
  <div :ref="'canvas'"  class="stage" :class="anim" />
</template>

<script>

export default {
  props: {
    anim: { type: String, default: '/anim/dealer.json', },
    gameState: { type: String, default: '', },
    dealerHeight: { type: Number, default: 216 }
  },
  data() {
    return {
      spine: null,
    }
  },
  watch: {
    gameState: function(newVal){
      // console.log('gameState', newVal);
      if(this.spine == null) return;
      if(newVal === "BETTING"){
        this.spine.state.setAnimation(0, 'moi cuoc2', true);
      }
      else if(newVal === "LOCKING"){
        this.spine.state.setAnimation(0, 'idle', true);
      }
      else if(newVal === "RESULTING"){
        const that = this;
        setTimeout(function(){
          if(newVal === "RESULTING"){
            that.spine.state.setAnimation(0, 'win', true);
          }
        }, 5000);
      }
    },
  },
  mounted() {
    // eslint-disable-next-line no-undef
    const app = new PIXI.Application({ 
      width: 368,
      height: this.dealerHeight,
      autoResize: true,
      transparent: true,
      resolution: window.devicePixelRatio
     });
    // document.body.appendChild(app.view);
    this.$refs.canvas.appendChild(app.view);

    // const anim = '/anim/dealer.json';
    const anim = `/anim/${this.anim}.json`;
    
    // load spine data
    app.loader
    .add('spineboy', anim)
      .load(onAssetsLoaded);

    app.stage.interactive = true;

    const that = this;

    function onAssetsLoaded(loader, res) {
      // console.log('anim', anim)
      // console.log('res.spineboy', res.spineboy)
      // console.log('res.spineboy.spineData', res.spineboy.spineData)

      // create a spine boy
      // eslint-disable-next-line no-undef
      const spineBoy = new PIXI.spine.Spine(res.spineboy.spineData);
      that.spine = spineBoy;

      // set the position
      spineBoy.x = app.screen.width / 2;
      spineBoy.y = app.screen.height;

      spineBoy.scale.set(0.2);

      // set up the mixes!
      // spineBoy.stateData.setMix('walk', 'jump', 0.2);
      // spineBoy.stateData.setMix('jump', 'walk', 0.4);

      // play animation
      spineBoy.state.setAnimation(0, 'moi cuoc2', true);

      app.stage.addChild(spineBoy);

    }
  },
  methods: {
    pop(event) {
    //   const mouseX = event.x;
    //   const mouseY = event.y;
    //   const particles = [];
    //   const spread = 100;

    //   for (let i = 0; i < 50; i++) {
    //     const particle = new PIXI.Graphics();
    //     const rand = anime.random(1, this.colors.length);
    //     particle.beginFill("0x" + this.colors[rand - 1]);
    //     particle.drawCircle(0, 0, 4);
    //     particle.endFill();
    //     particle.x = mouseX;
    //     particle.y = mouseY;
    //     particles.push(particle);
    //     this.app.stage.addChild(particle);
    //   }

    //   anime({
    //     targets: particles,
    //     x() {
    //       return anime.random(mouseX - spread, mouseX + spread);
    //     },
    //     y() {
    //       return anime.random(mouseY - spread, mouseY + spread);
    //     },
    //     alpha: { delay: 300, duration: 500, value: 0 },
    //     easing: "easeOutQuint",
    //     complete: () => {
    //       for (const particle of particles) {
    //         this.app.stage.removeChild(particle);
    //       }
    //     }
    //   });
    }
  }
};


</script>
